import { create } from 'zustand';
// import { toNano } from '@ton/core';

interface IClaimResult {
  txUrl: string;
  success: boolean;
  amount?: string;
}

interface GlobalState {
  claimResult: IClaimResult | null;
  setClaimResult: (r: IClaimResult) => void;
  clearClaimResult: () => void;
}

// const result = {
//   txUrl: '',
//   success: true,
//   amount: toNano(2000)
// };

export const useGlobalStore = create<GlobalState>()((set) => ({
  claimResult: null,
  setClaimResult: (result) => set(() => ({ claimResult: result })),
  clearClaimResult: () => set({ claimResult: null })
}));

interface IContainerState {
  container?: HTMLDivElement | null;
  setContainer: (v: HTMLDivElement | null) => void;
}

export const useContainerStore = create<IContainerState>((set) => ({
  container: null,
  setContainer: (v) => set({ container: v })
}));
